import { Injectable } from '@angular/core';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor() {
    window.dataLayer = window.dataLayer || [];
  }


  trackEvent(eventName: string, params: any = {}) {

    window.dataLayer.push({
      event: eventName,
      ...params
    });


    console.log('GTM Event Sent:', {
      eventName,
      params
    });

  }

}